import type { QueryClient } from "@tanstack/react-query";

import type { PlanUsageSnapshot } from "@/hooks/queries/usePlanUsageQuery";
import { queryKeys } from "@/lib/react-query/query-keys";

export function patchPlanUsageSnapshot(
  qc: QueryClient,
  patch: Partial<PlanUsageSnapshot>,
) {
  qc.setQueryData<PlanUsageSnapshot>(queryKeys.planUsage(), (existing) =>
    existing ? { ...existing, ...patch } : existing,
  );
}

export function adjustPlanUsageStarredCount(qc: QueryClient, delta: number) {
  qc.setQueryData<PlanUsageSnapshot>(queryKeys.planUsage(), (existing) => {
    if (!existing) return existing;
    return {
      ...existing,
      starredCount: Math.max(0, existing.starredCount + delta),
    };
  });
}

export function adjustPlanUsagePublishedCount(qc: QueryClient, delta: number) {
  qc.setQueryData<PlanUsageSnapshot>(queryKeys.planUsage(), (existing) => {
    if (!existing) return existing;
    return {
      ...existing,
      publishedCount: Math.max(0, existing.publishedCount + delta),
    };
  });
}
